import type { ReactNode } from 'react'

import { use, useEffect } from 'react'

import { PageNavigatorContext } from './PageNavigator'

export default function PageNavigatorRegister({
	children,
	id,
}: {
	children: ReactNode
	id?: string
}) {
	const { register, unregister } = use(PageNavigatorContext)
	useEffect(() => {
		register(children)

		return () => {
			unregister()
		}
	}, [id, children])

	return null
}
